export default {
  en: {
    ACCOUNT_PAGE_ADDRESS_TT: 'The physical location associated with your business or billing address.',
    ACCOUNT_PAGE_ADDRESS_TWO_DEFAULT: 'Optional',
    ACCOUNT_PAGE_ADDRESS_TWO_TT: '',
    ACCOUNT_PAGE_ADDRESS_TWO: '',
    ACCOUNT_PAGE_ADDRESS: 'Address',
    ACCOUNT_PAGE_CITY_TT: 'The city you or your business are located in.',
    ACCOUNT_PAGE_CITY: 'City',
    ACCOUNT_PAGE_COMPANY_TT: 'The name of your company.',
    ACCOUNT_PAGE_COMPANY: 'Company',
    ACCOUNT_PAGE_COUNTRY_DEFAULT: 'Enter Country',
    ACCOUNT_PAGE_COUNTRY_TT: 'Select the country you are located in.',
    ACCOUNT_PAGE_COUNTRY: 'Country',
    ACCOUNT_PAGE_CREATE_MESSAGE: 'Account has been created successfully, redirecting to Dashboard.',
    ACCOUNT_PAGE_ERROR_MESSAGE: 'Failed to create account do to:',
    ACCOUNT_PAGE_STATE_DEFAULT: 'Select',
    ACCOUNT_PAGE_STATE_TT: 'The state you or your business are located in.',
    ACCOUNT_PAGE_STATE: 'State',
    ACCOUNT_PAGE_TIME_ZONE_TT: 'Select the time zone you are located in.',
    ACCOUNT_PAGE_TIME_ZONE: 'Time Zone',
    ACCOUNT_PAGE_TITLE: 'Edit Account',
    ACCOUNT_PAGE_UPDATE_BUTTON: 'Update',
    ACCOUNT_PAGE_UPDATE_MESSAGE: 'Account has been updated.',
    ACCOUNT_PAGE_UPDATING: 'Updating...',
    ACCOUNT_PAGE_ZIP_TT: 'The zip code you or your business are located in.',
    ACCOUNT_PAGE_ZIP: 'Zip Code',
    ACCOUNT_DETAILS_LOADING: 'Loading Account Details',
    BLOCK_CALLS_SHAKEN_STIR: 'Require Stir/Shaken Attestation',
    BLOCK_CALLS_SHAKEN_STIR_TT: 'When enabled, calls that are not compliant with the required Stir/Shaken attestation level will be blocked. This setting is only applied to calls with valid attestation.',
    BLOCK_CALLS_SHAKEN_STIR_OPTIONS: 'Required attestation level:',
    BLOCK_CALLS_SHAKEN_STIR_OPTIONS_TT: 'Choose which set of attestations you want to allow. Incoming calls that do not meet the required attestation level will be blocked. <br/><br/> A: Full Attestation - Indicates that the provider recognizes the entire phone number as being registered with the originating subscriber. <br/><br/> B: Partial Attestation - Indicates that the call originated with a known customer but the entire number cannot be verified. <br/><br/> C: Gateway Attestation - Indicates that the call can only be verified as coming from a known gateway.',
    BUYER_EXTRA_TAGS: 'Allow Buyers to See Selected Tags',
    BUYER_EXTRA_TAGS_TT: 'Once enabled you will be able to add the ability to all buyers in your account to see the selected tags below.',
    BUYER_EXTRA_TAGS_OPTIONS: 'Allowed Tags in Buyers View',
    BUYER_EXTRA_TAGS_OPTIONS_TT: 'Choose which extra tags buyers will see in reporting page.',
    BUYER_EXTRA_TAGS_SELECT_A_TAG: 'Select a tag',
    BUYER_EXTRA_TAGS_SELECTED_TAGS: 'Selected tags:',
    //errors
    TIMEZONE_LOAD_ERROR_MESSAGE: 'Error loading timezones',
    STATES_LOAD_ERROR_MESSAGE: 'Error loading states',
    FORM_VALIDATION_ERROR: 'Please fill out all required fields'
  }
};
